import React, { useEffect, useState } from 'react';
import { GetParams } from '../../../../Helper';
import { TabsComponent } from '../../../../Components';
import { LeasingTransactionsProfileTabs } from './LeasingTransactionsWithAMLProfileTabs';
import { useSelector } from 'react-redux';

const parentTranslationPath = 'LeasingTransactionsProfileView';
const translationPath = '';
export const LeasingTransactionsWithAMLProfile = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [params, setParams] = useState({
    unitId: null,
    unitTransactionId: null,
  });
  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };
  useEffect(() => {
    const unitId = GetParams('unitId');
    const unitTransactionId = GetParams('unitTransactionId');
    if (unitTransactionId || unitId) {
      setParams({
        unitId: (unitId && +unitId) || null,
        unitTransactionId: (unitTransactionId && +unitTransactionId) || null,
      });
    }
  }, []);
  const transactionActiveItem = useSelector((state) => state.ActiveItemReducer);
  return (
    <div className='leasing-transactions-profile-wrapper view-wrapper'>
      <TabsComponent
        data={LeasingTransactionsProfileTabs}
        labelInput='label'
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        themeClasses='theme-solid'
        currentTab={activeTab}
        onTabChanged={onTabChanged}
        dynamicComponentProps={{
          ...params,
          parentTranslationPath,
          translationPath,
          transactionActiveItem
        }}
      />
    </div>
  );
};
